import { usePermission } from '@backstage/plugin-permission-react';
import {
  developerPortalSupportAgentReadPermission,
  developerPortalSupportAgentCreatePermission,
  developerPortalSupportAgentUpdatePermission,
  developerPortalSupportAgentDeletePermission,
} from '@internal/backstage-plugin-developer-portal-support-agent-common';

/**
 * Resolves all developer portal support agent RBAC permissions through the
 * permission backend so components don't need to repeat the `usePermission`
 * calls and aggregate their loading/error state by hand.
 */
export const useDeveloperPortalSupportAgentPermissions = (): {
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  loading: boolean;
  error?: Error;
} => {
  const {
    allowed: canRead,
    loading: loadingRead,
    error: readError,
  } = usePermission({ permission: developerPortalSupportAgentReadPermission });
  const {
    allowed: canCreate,
    loading: loadingCreate,
    error: createError,
  } = usePermission({
    permission: developerPortalSupportAgentCreatePermission,
  });
  const {
    allowed: canUpdate,
    loading: loadingUpdate,
    error: updateError,
  } = usePermission({
    permission: developerPortalSupportAgentUpdatePermission,
  });
  const {
    allowed: canDelete,
    loading: loadingDelete,
    error: deleteError,
  } = usePermission({
    permission: developerPortalSupportAgentDeletePermission,
  });

  return {
    canRead,
    canCreate,
    canUpdate,
    canDelete,
    loading: loadingRead || loadingCreate || loadingUpdate || loadingDelete,
    error: readError || createError || updateError || deleteError,
  };
};
